import { Namespace } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LimitsHeader } from '../LimitsHeader';
import { HeaderSlice, PageTitle } from '../../pages/common/styles';

import { HeaderWrapper } from './styles';

export const Header = () => {
  const { t } = useTranslation<Namespace<'talk'>>('talk');

  return (
    <HeaderWrapper>
      <HeaderSlice>
        <PageTitle>{t('title')}</PageTitle>
        <LimitsHeader />
      </HeaderSlice>
    </HeaderWrapper>
  );
};
